import React from "react";
import { CContainer, CHeader, CHeaderNav } from "@coreui/react";
import { matchPath, useLocation, useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import AppHeaderDropdown from "../appHeaderDropdown";
import { ROUTE_META } from "../../routes/routeNames";

const SORTED_ROUTE_PATHS = Object.keys(ROUTE_META).sort(
  (a, b) => b.length - a.length
);

const HeaderTitles = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const matchedPath = SORTED_ROUTE_PATHS.find((path) =>
    matchPath({ path, end: true }, pathname)
  );
  const headerTitle = matchedPath ? ROUTE_META[matchedPath].name : "";
  const headerDescription = matchedPath
    ? ROUTE_META[matchedPath].description
    : "";
  const showBackButton = pathname.split("/").filter(Boolean).length > 1;

  return (
    <CHeaderNav className="etd-header">
      <div className="etd-header-left">
        {showBackButton && (
          <button
            type="button"
            className="etd-back-btn"
            onClick={() => navigate(-1)}
          >
            <FiArrowLeft />
          </button>
        )}
        <div>
          <h3 className="etd-title">{headerTitle}</h3>
          <p className="etd-subtitle">{headerDescription}</p>
        </div>
      </div>
    </CHeaderNav>
  );
};

/**
 * @function AppHeader
 * @description Sticky admin header. Title bar owns location updates so the
 * profile dropdown does not rerender on every screen switch.
 * @returns JSX for navbar
 */
const AppHeader = () => {
  return (
    <CHeader position="sticky" className="mb-2 p-0">
      <CContainer className="border-bottom px-4 d-flex" fluid>
        <HeaderTitles />
        <CHeaderNav>
          <AppHeaderDropdown />
        </CHeaderNav>
      </CContainer>
    </CHeader>
  );
};

export default React.memo(AppHeader);
